export default {
  VALIDATE: "Validate order",
  PURCHASES_ORDER_VALIDATED: "Order validated",
  SEND_NOW_QUESTION: "Send the order now?",
  SEND_NOW_HINT: "You can email the order to the supplier right away to avoid forgetting.",
  SENT_BY: "Sent by",
  SENT_TO: "Sent to",
  SENT_AT: "Sent at",
  TO: "To",
  CC: "Cc",
  BCC: "Bcc",
  VALIDATE_DELIVERY_DATE_TITLE: "Validate order",
  SELECT_EXPECTED_DELIVERY_DATE: "Select an expected delivery date",
  NO_ALLOWED_DELIVERY_DATES:
    "No expected delivery date is available from the supply rules. The order can be validated without an expected date.",
  DEPOSITS: "Deposits",
  CHARGE_NOT_TAXABLE: "Not taxable",
  TRANSPORTATION_FEES: "Transportation / fuel fees",
  CHARGES: "Charges",
  OTHER_CHARGES: "Other charges",
  NO_TAXES: "No taxes",
  TAXES_TPS_TVQ: "Taxes: TPS/TVQ",
  CANCEL_PURCHASES_ORDER_WARNING:
    "If you cancel this order, it will be irrecoverable and will not appear in the weekly report.",
  ADVANCED_MODE: "Advanced mode",
  SHOW_CHECKED: "Show processed",
  SHOW_UNCHECKED: "Show unprocessed",
  SHOW_ONLY_WITH_TAXES: "With taxes only",
  SET_ALL_QUANTITIES_TO_ZERO: "Set all to zero",
  ORDER_STATUS_DRAFT: "Draft",
  ORDER_STATUS_CANCELED: "Canceled",
  ORDER_STATUS_VALIDATED: "Validated",
  ORDER_STATUS_COMPLETED: "Completed",
  INVOICING_STATUS_PENDING: "Not invoiced",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partially invoiced",
  INVOICING_STATUS_INVOICED: "Invoiced",
};
